(function () {
  var BASE = '/products/';
  var WA = 'https://api.whatsapp.com/send/?phone=%2B447899539620';
  var MASKS = window.MFD.MASKS, QUESTIONS = window.MFD.QUESTIONS, ic = window.MFI;
  function isMouthy(m) { return m.t === 'full' || m.t === 'hybrid'; }
  function score(a) {
    var out = [];
    MASKS.forEach(function (m) {
      var s = m.pop || 0, why = [], hide = false;
      var mouthy = isMouthy(m);
      if (a.breath === 'mouth') {
        if (!mouthy) hide = true; else { s += 6; why.push('Seals mouth and nose, which suits mouth breathers'); }
      } else if (a.breath === 'nose') {
        if (m.t === 'nasal' || m.t === 'pillow') { s += 6; why.push('Nose-only design suits nose breathers'); }
        else if (a.press === 'high') s -= 2;
        else hide = true;
      } else {
        if (m.t === 'full') { s += 3; why.push('Full face coverage is the most forgiving if you’re unsure how you breathe'); }
        else if (m.t === 'hybrid') s += 1;
      }
      if (m.tube) {
        if (a.sleep === 'side') { s += 3; why.push('Tube-up design stays out of the way when you sleep on your side'); }
        else if (a.sleep === 'stomach') { s += 4; why.push('Tube-up design is a good match for stomach sleepers'); }
        else if (a.sleep === 'mixed') { s += 3; why.push('Tube-up design copes well with changing position'); }
      } else if (a.sleep === 'back' && m.classic) { s += 1; }
      else if (a.sleep === 'stomach' || a.sleep === 'side') { s -= 1; }
      if (a.feel === 'min') {
        s += m.min * 2;
        if (m.min >= 2) why.push('Low-profile, minimal-contact design');
      } else if (a.feel === 'secure') {
        if (m.classic) { s += 3; why.push('Classic, stable fit with a secure seal'); }
      } else if (a.feel === 'soft') {
        if (m.soft) { s += 5; why.push('Soft cushion material, gentle on sensitive skin'); }
      }
      if (a.view === 'yes' && m.open) { s += 3; why.push('Keeps your line of sight clear for glasses, reading or TV'); }
      if (a.press === 'high') {
        if (m.highP) { s += 9; why.push('Rated for higher therapy pressures'); }
        else s -= 2;
      }
      if (a.budget === 'low') {
        if (m.p < 60) { s += 8; why.push('Fits your budget'); }
      } else if (a.budget === 'mid') {
        if (m.p <= 110) s += 2;
      }
      if (m.airmini) { if (a.machine === 'airmini') { s += 25; why.unshift('Made to work with the ResMed AirMini'); } else hide = true; }
      else if (a.machine === 'airmini' && !m.airmini) { s -= 2; }
      if (!hide) out.push({m: m, s: s, why: why.slice(0, 3), over: false});
    });
    out.sort(function (x, y) { return y.s - x.s || x.m.p - y.m.p; });
    var ordered = out;
    /* budget is a firm limit: in-budget masks first, anything above is flagged */
    if (a.budget === 'low') {
      var under = out.filter(function (x) { return x.m.p < 60; });
      var rest = out.filter(function (x) { return x.m.p >= 60; });
      if (a.breath === 'nose') rest.sort(function (x, y) { return (y.m.airmini ? 1 : 0) - (x.m.airmini ? 1 : 0) || x.m.p - y.m.p; });
      rest.forEach(function (x) { x.over = true; });
      ordered = under.concat(rest);
    } else if (a.budget === 'mid') {
      var inb = out.filter(function (x) { return x.m.p <= 110 || x.m.airmini; });
      var above = out.filter(function (x) { return !(x.m.p <= 110 || x.m.airmini); });
      above.forEach(function (x) { x.over = true; });
      ordered = inb.concat(above);
    }
    /* nose breathers: nose masks only, plus one full face option in the last slot when pressure is high */
    if (a.breath === 'nose' && a.press === 'high') {
      var nf = ordered.filter(function (x) { return !isMouthy(x.m); });
      var fl = ordered.filter(function (x) { return isMouthy(x.m); });
      ordered = nf.slice(0, 2).concat(fl.slice(0, 1));
    }
    return ordered.slice(0, 3);
  }
  function notes(a, res) {
    var n = [];
    if (a.budget === 'low' && res) {
      var overN = res.filter(function (r) { return r.over; }).length;
      if (a.breath === 'nose') {
        var minNose = Math.min.apply(null, MASKS.filter(function (m) { return !isMouthy(m) && !m.airmini; }).map(function (m) { return m.p; }));
        n.push('Our masks under £60 are full face, which doesn’t suit nose breathing. Nose-only masks start at £' + minNose.toFixed(2) + ', so these are the closest matches just above your budget.');
      } else if (overN > 0) {
        n.push('Only two of our masks are under £60. Your other match is slightly above budget.');
      }
    }
    if (a.breath === 'nose' && a.press === 'high') n.push('At higher pressures, air can leak from the mouth. If you wake with a dry mouth, a full face mask may be a better choice, so we have included one. Check with your clinician.');
    if (a.machine === 'airmini' && a.breath === 'mouth') n.push('Our AirMini-ready masks are nose-based. For full face use with an AirMini, contact us and we’ll check compatibility.');
    if (a.press === 'unk') n.push('If you can, check your pressure setting or prescription, as it can affect which mask works best.');
    n.push('Sizing: most masks come in several sizes, and FitPacks include more than one cushion so you can find your fit first time.');
    return n;
  }
  function tags(m) {
    var t = [];
    if (m.tube) t.push('Tube-up');
    if (m.open) t.push('Clear view');
    if (m.soft) t.push('Soft cushion');
    if (m.highP) t.push('High pressure');
    if (m.small) t.push('Smaller faces');
    if (m.cheap) t.push('Great value');
    return t.slice(0, 3);
  }
  var TYPE = {full:'Full face', nasal:'Nasal', pillow:'Nasal pillow', hybrid:'Hybrid'};
  var state = {i: 0, a: {}, max: 0};
  var root = document.getElementById('mf-root');
  var card = document.getElementById('mf-card');
  var stepsEl = document.getElementById('mf-steps');
  var timer = null;
  document.getElementById('mf-trust').innerHTML =
    '<li>' + ic('truck') + 'Free next day shipping</li><li>' + ic('shieldcheck') + 'Genuine brands</li><li>' + ic('chat') + 'Real people to help</li>';
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function focusHeading() {
    var h = card.querySelector('[data-focus]');
    if (h) { try { h.focus({preventScroll: true}); } catch (e) { h.focus(); } }
  }
  function ensureVisible() {
    var r = card.getBoundingClientRect();
    if (r.top < 60 || r.top > window.innerHeight * 0.6) {
      try { card.scrollIntoView({behavior: 'smooth', block: 'start'}); } catch (e) { card.scrollIntoView(); }
    }
  }
  function renderSteps(allDone) {
    var h = '';
    QUESTIONS.forEach(function (q, idx) {
      var done = allDone || idx < state.i || (idx < state.max && state.a[q.k]);
      var cur = !allDone && idx === state.i;
      var can = !cur && (allDone || idx <= state.max) && !!state.a[q.k];
      h += '<li><button type="button" class="mf-step' + (done ? ' done' : '') + (cur ? ' cur' : '') + (can ? ' can' : '') + '" data-i="' + idx + '"' + (cur ? ' aria-current="step"' : '') + (can ? '' : ' tabindex="-1"') + '><span class="mf-dot">' + (done ? ic('check') : (idx + 1)) + '</span>' + esc(q.st) + '</button></li>';
    });
    stepsEl.innerHTML = h;
    Array.prototype.forEach.call(stepsEl.querySelectorAll('.mf-step.can'), function (b) {
      b.addEventListener('click', function () { clearTimeout(timer); state.i = +b.getAttribute('data-i'); renderQ(false); });
    });
  }
  function renderQ(noScroll) {
    clearTimeout(timer);
    root.classList.remove('mf-wide');
    var q = QUESTIONS[state.i], total = QUESTIONS.length, cur = state.a[q.k];
    if (state.i > state.max) state.max = state.i;
    var h = '<div class="mf-pane">';
    h += '<div class="mf-meta"><span>Question ' + (state.i + 1) + ' of ' + total + '</span><span class="mf-tag">' + esc(q.st) + '</span></div>';
    h += '<div class="mf-segs" role="progressbar" aria-label="Progress" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + state.i + '">';
    for (var s = 0; s < total; s++) h += '<i' + (s <= state.i ? ' class="on"' : '') + '></i>';
    h += '</div>';
    h += '<h2 class="mf-q" id="mf-q" tabindex="-1" data-focus>' + esc(q.q) + '</h2>';
    if (q.help) h += '<p class="mf-help">' + esc(q.help) + '</p>';
    h += '<div class="mf-opts' + (q.cols ? ' ' + q.cols : '') + '" role="group" aria-labelledby="mf-q">';
    q.o.forEach(function (o) {
      h += '<button type="button" class="mf-opt" data-v="' + o.v + '" aria-pressed="' + (cur === o.v) + '"><span class="mf-ico">' + ic(o.i) + '</span><span><b>' + esc(o.t) + '</b>' + (o.s ? '<small>' + esc(o.s) + '</small>' : '') + '</span></button>';
    });
    h += '</div><div class="mf-nav"><button type="button" class="mf-link" id="mf-back"' + (state.i === 0 ? ' disabled' : '') + '>' + ic('left') + ' Back</button>';
    h += '<button type="button" class="mf-btn mf-btn-primary" id="mf-next"' + (cur ? '' : ' disabled') + '>' + (state.i === total - 1 ? 'See my matches' : 'Next') + ' ' + ic('right') + '</button></div></div>';
    card.innerHTML = h;
    renderSteps(false);
    if (state.i > 0 || noScroll === false) { focusHeading(); ensureVisible(); }
    Array.prototype.forEach.call(card.querySelectorAll('.mf-opt'), function (b) {
      b.addEventListener('click', function () {
        state.a[q.k] = b.getAttribute('data-v');
        Array.prototype.forEach.call(card.querySelectorAll('.mf-opt'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        card.querySelector('#mf-next').disabled = false;
        clearTimeout(timer);
        timer = setTimeout(advance, 380);
      });
    });
    card.querySelector('#mf-back').addEventListener('click', function () { clearTimeout(timer); if (state.i > 0) { state.i--; renderQ(false); } });
    card.querySelector('#mf-next').addEventListener('click', function () { clearTimeout(timer); advance(); });
  }
  function advance() {
    var q = QUESTIONS[state.i];
    if (!state.a[q.k]) return;
    if (state.i < QUESTIONS.length - 1) { state.i++; renderQ(false); } else showLoading();
  }
  function showLoading() {
    root.classList.remove('mf-wide');
    card.innerHTML = '<div class="mf-pane mf-loading"><div class="mf-pulse" aria-hidden="true"><i></i><i></i><i></i></div><h2 data-focus tabindex="-1">Finding your best matches…</h2><p>Comparing your answers with our in-stock masks.</p></div>';
    renderSteps(true);
    focusHeading(); ensureVisible();
    timer = setTimeout(renderResults, 1100);
  }
  function summaryChips() {
    return QUESTIONS.map(function (q) {
      var v = state.a[q.k], o = q.o.filter(function (x) { return x.v === v; })[0];
      return o ? '<li>' + esc(o.r) + '</li>' : '';
    }).join('');
  }
  function renderResults() {
    var res = score(state.a), labels = ['Best match', 'Also great', 'Worth considering'];
    root.classList.add('mf-wide');
    var h = '<div class="mf-pane mf-results"><div class="mf-rhead"><div><h2 data-focus tabindex="-1">Here’s what we’d try first</h2><ul class="mf-summary">' + summaryChips() + '</ul></div>';
    h += '<div><button type="button" class="mf-link" id="mf-edit">' + ic('edit') + ' Edit answers</button></div></div>';
    h += '<div class="mf-notes">' + ic('bulb') + '<div>' + notes(state.a, res).map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') + '</div></div>';
    h += '<div class="mf-grid">';
    res.forEach(function (r, i) {
      var m = r.m, url = BASE + m.h, why = r.why.length ? r.why : [m.tip];
      h += '<article class="mf-res' + (i === 0 ? ' mf-top' : '') + '">';
      h += '<a class="mf-imgwrap" href="' + url + '" aria-label="' + esc(m.n) + '"><img src="' + m.img + '" alt="' + esc(m.n) + '" loading="lazy"></a>';
      h += '<div class="mf-body"><span class="mf-badge">' + labels[i] + '</span>';
      h += '<div class="mf-brand">' + esc(m.b) + ' &middot; ' + TYPE[m.t] + '</div><h3>' + esc(m.n) + '</h3>';
      h += '<ul class="mf-why">' + why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>';
      var tg = tags(m).slice(0, r.over ? 2 : 3).map(function (t) { return '<li>' + t + '</li>'; });
      if (r.over) tg.unshift('<li class="over">Above budget</li>');
      if (tg.length) h += '<ul class="mf-tags">' + tg.join('') + '</ul>';
      h += '<div class="mf-foot-row"><div class="mf-price"><small>From</small>£' + m.p.toFixed(2) + '</div><a class="mf-btn mf-btn-primary" href="' + url + '">View mask ' + ic('right') + '</a></div></div></article>';
    });
    h += '</div>';
    h += '<div class="mf-after"><button type="button" class="mf-btn mf-btn-ghost" id="mf-redo">' + ic('refresh') + ' Start again</button><a class="mf-btn mf-btn-ghost" href="/collections/cpap-masks">Browse all masks</a></div>';
    h += '<div class="mf-help-panel"><div><h4>Still not sure? Talk to us</h4><p>Tell us how you sleep and which machine you use, and we’ll help you pick the right mask and size.</p></div>';
    h += '<div class="acts"><a class="mf-btn mf-btn-primary" href="' + WA + '" target="_blank" rel="noopener">' + ic('chat') + ' WhatsApp us</a><a class="mf-btn mf-btn-ghost" href="/pages/contact">Contact page</a></div></div></div>';
    card.innerHTML = h;
    renderSteps(true);
    card.querySelector('#mf-redo').addEventListener('click', function () { state = {i: 0, a: {}, max: 0}; renderQ(false); });
    card.querySelector('#mf-edit').addEventListener('click', function () { state.i = 0; renderQ(false); });
    focusHeading(); ensureVisible();
  }
  window.CMF = {score: score, MASKS: MASKS, QUESTIONS: QUESTIONS};
  renderQ(true);
})();